<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 21 17">
    <path
      d="M18.5 6V3.7C18.5 2.5799 18.5 2.01984 18.282 1.59202C18.0903 1.2157 17.7843 0.909736 17.408 0.717989C16.9802 0.500003 16.4201 0.500002 15.3 0.5H3.7C2.5799 0.5 2.01984 0.5 1.59202 0.717987C1.2157 0.909734 0.909734 1.21569 0.717987 1.59202C0.5 2.01984 0.5 2.5799 0.5 3.7V13.3C0.5 14.4201 0.5 14.9802 0.717987 15.408C0.909734 15.7843 1.21569 16.0903 1.59202 16.282C2.01984 16.5 2.57989 16.5 3.7 16.5L15.3 16.5C16.4201 16.5 16.9802 16.5 17.408 16.282C17.7843 16.0903 18.0903 15.7843 18.282 15.408C18.5 14.9802 18.5 14.4201 18.5 13.3V11M13.5 8.5C13.5 8.03535 13.5 7.80302 13.5384 7.60982C13.6962 6.81644 14.3164 6.19624 15.1098 6.03843C15.303 6 15.5353 6 16 6H18C18.4647 6 18.697 6 18.8902 6.03843C19.6836 6.19624 20.3038 6.81644 20.4616 7.60982C20.5 7.80302 20.5 8.03535 20.5 8.5C20.5 8.96466 20.5 9.19698 20.4616 9.39018C20.3038 10.1836 19.6836 10.8038 18.8902 10.9616C18.697 11 18.4647 11 18 11H16C15.5353 11 15.303 11 15.1098 10.9616C14.3164 10.8038 13.6962 10.1836 13.5384 9.39018C13.5 9.19698 13.5 8.96465 13.5 8.5Z"
      :class="colorClass"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
